export default class ClubFinancialAccountingDatevExport {
    static fromData(data) {
        if (!data) {
            return;
        }

        let datevExport = new ClubFinancialAccountingDatevExport();

        datevExport.id = data.id;
        datevExport.bookingPeriod = data.bookingPeriod;
        datevExport.attachmentName = data.attachmentName;
        datevExport.formattedCreatedAt = data.formattedCreatedAt;
        datevExport.formattedInvoicePeriod = data.formattedInvoicePeriod;

        return datevExport;
    }
}
